export const normalizePayload = <T extends Record<string, unknown>>(payload: T) =>
    Object.entries(payload).reduce(
        (_acc, [key, value]) => ({
            ..._acc,
            [key]: typeof value === 'string' && value.trim() === '' ? null : value
        }),
        {} as T
    );
